import React, { useContext, useEffect, useRef, useState } from "react";
import { Box } from "@mui/system";
import Moment from "moment";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import ZoomOutOutlinedIcon from "@mui/icons-material/ZoomOutOutlined";
import ZoomInOutlinedIcon from "@mui/icons-material/ZoomInOutlined";
import HowToRegTwoToneIcon from "@mui/icons-material/HowToRegTwoTone";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import Backdrop from "@mui/material/Backdrop";
import Button from "@mui/material/Button";
import Api_Call from "../../ApiCall";
import UserContext from "../Common/UserContext";
import { HeaderTitle } from "./HeaderTitle";
// import { Fields } from "./Fields";
import { FieldsClinical } from "./FieldsClinical";
import { BasicTable } from "./Tables";
import { FormFieldsDialog } from "./FormFieldsDialog";

import { ApiCall } from "../../utility/ApiCalls";
import "./../styles/FieldGroup.css";

export const FieldGroupClinical = (props) => {
  const history = useHistory();
  // Canvas Drawing
  const canvasRef = useRef(null);
  const imageRef = useRef(null);
  const [start, setStart] = useState({ x: 0, y: 0 });
  const [end, setEnd] = useState({ x: 0, y: 0 });
  const [isDrawing, setIsDrawing] = useState(false);

  const [pdfImgWidth, setPdfImgWidth] = useState(0);
  const [pdfImgHeight, setPdfImgHeight] = useState(0);
  const [pdfImgScale, setPdfImgScale] = useState(0);
  const [zoomBoxOutPos, setZoomBoxOutPos] = useState(true);
  const [validateFieldMemberId, setValidateFieldMemberId] = useState(false);
  const [validateFieldDob, setValidateFieldDob] = useState(false);
  const [validateFieldFirstName, setValidateFieldFirstName] = useState(false);
  const [validateFieldLastName, setValidateFieldLastName] = useState(false);
  const [validateFieldRequestorName, setValidateFieldRequestorName] =
    useState(false);
  const [validateFieldRequestorPhone, setValidateRequestorPhone] =
    useState(false);
  const [validateFieldRequestorFax, setValidateFieldRequestorFax] =
    useState(false);
  const [
    validateFieldAnticipatedStartDate,
    setValidateFieldAnticipatedStartDate,
  ] = useState(false);
  const [unableLocate, setUnableLocate] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const [selectedCoordinates, setSelectedCoordinates] = useState("");
  const [backdropLoading, setBackdropLoading] = useState(false);
  const [formFieldName, setFormFieldName] = useState("");
  const image = imageRef.current;
  const [originalValue, setOriginalValue] = useState("");
  const { userId } = useContext(UserContext);
  // ============== Canvas selection STARTS =========================

  // useEffect(() => {
  //   const image = imageRef.current;

  //   if (image) {
  //     image.onload = () => {
  //       console.log("imageRef useEffect ===> ", image.width, image.height);

  //       // canvas.width = image.width;
  //       // canvas.height = image.height;
  //       // // ctx.drawImage(image, 0, 0);
  //       // ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
  //     };
  //   }
  // }, [imageRef]);

  useEffect(() => {
    const canvas = canvasRef.current;
    fieldClickHandel();
    if (props.showCanvas) {
      console.log("WIDTH HEIGHT ===> ", props.imageDimension);
      const ctx = canvas && canvas.getContext("2d");
      // if (props.fieldGroup === "pdf_box") {
      //   localStorage.removeItem("ImageData");
      //   localStorage.setItem("ImageData", JSON.stringify(props));
      // }
      canvas.width = props.imageDimension.width;
      canvas.height = props.imageDimension.height;
      ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    }
  }, [props.showCanvas]);

  const handleMouseDown = (event) => {
    setIsDrawing(true);
    console.log("WIDTH HEIGHT ===> ", props.imageDimension);
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    canvas.width = props.imageDimension.width;
    canvas.height = props.imageDimension.height;

    const { left, top } = canvas.getBoundingClientRect();
    setStart({
      x: event.clientX - left,
      y: event.clientY - top,
    });
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(imageRef.current, 0, 0, canvas.width, canvas.height);
  };

  const handleMouseMove = (event) => {
    if (!isDrawing) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    canvas.width = props.imageDimension.width;
    canvas.height = props.imageDimension.height;

    const { left, top } = canvas.getBoundingClientRect();
    setEnd({
      x: event.clientX - left,
      y: event.clientY - top,
    });
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(imageRef.current, 0, 0, canvas.width, canvas.height);
    ctx.fillStyle = "rgba(0, 0, 0, 0.25)";
    ctx.fillRect(start.x, start.y, end.x - start.x, end.y - start.y);
  };

  const handleMouseUp = () => {
    setIsDrawing(false);
    setIsSelected(true);
    let finalCoordinate = "";
    finalCoordinate = `${start.x / props.imageDimension.width}, ${
      start.y / props.imageDimension.height
    }, ${end.x / props.imageDimension.width}, ${
      end.y / props.imageDimension.height
    }`;
    setSelectedCoordinates(finalCoordinate);
    setOpenMenu(true);
  };
  const handleDialogClose = () => {
    setOpenMenu(false);
    props.setShowCanvas(false);
    props.setCallValidateAPI(true);
  };

  console.log(props.selectedField, selectedCoordinates);
  const handleDialogUpdate = () => {
    let requestBody = {
      field_name: props.selectedField, //MemberID
      coordinates: selectedCoordinates,
      taskID: sessionStorage.getItem("ActiveTaskID"),
    };
    updateFieldCoordinates(requestBody);
    // setOpenMenu(false);
  };
  // ============== Canvas selection END =========================
  const zoomToggleHandel = () => {
    setZoomBoxOutPos(zoomBoxOutPos ? false : true);
    var lens = document.getElementById("highlightbox");
    var result = document.getElementById("myresult");
    result.style.border = "1px solid #fb4e0b";
    if (zoomBoxOutPos) {
      result.style.left = lens.style.left;
      result.style.top = lens.style.top;
    } else {
      result.style.top = "-80px";
      result.style.right = "10px";
      result.style.left = "auto";
    }
  };

  var columsCPT = [
    {
      Header: "CPT Code / Request",
      accessor: "CPTCode_CR",
      Cell: ({ row }) => {
        return (
          <>
            <div
              onMouseEnter={(e) =>
                getCoordinates(e, props.ocrData.CPTCodes.coordinates)
              }
            >
              {row.values.CPTCode_CR}
            </div>
          </>
        );
      },
    },
    {
      Header: "Units",
      accessor: "Unit_NR",
    },
  ];

  var columnsDX = [
    {
      Header: "Diagnosis Code",
      accessor: "DXCode_CR",
      Cell: ({ row }) => {
        return (
          <>
            <div
              onMouseEnter={(e) =>
                getCoordinates(e, props.ocrData["DiagnosisCodes"].coordinates)
              }
            >
              {row.values.DXCode_CR}
            </div>
          </>
        );
      },
    },
  ];

  var columnsProvider = [
    {
      Header: "Provider Name",
      accessor: "ProviderName",
      Cell: ({ row }) => {
        return (
          <>
            {row.id == "0" ? (
              <>
                <span
                  onMouseEnter={(e) =>
                    getCoordinates(e, row.original.Name_Coordinates)
                  }
                  className={`addProviderName1Focus ${
                    props.confidenceCheck
                      ? row.original.Name_Confidence < 0.3
                        ? "before30Text"
                        : row.original.Name_Confidence < 0.7
                        ? "before70Text"
                        : ""
                      : ""
                  }`}
                >
                  {row.values.ProviderName}
                </span>
              </>
            ) : (
              <>
                <span
                  onMouseEnter={(e) =>
                    getCoordinates(e, row.original.Name_Coordinates)
                  }
                  className={`addProviderName2Focus ${
                    props.confidenceCheck
                      ? row.original.Name_Confidence < 0.3
                        ? "before30Text"
                        : row.original.Name_Confidence < 0.7
                        ? "before70Text"
                        : ""
                      : ""
                  }`}
                >
                  {row.values.ProviderName}
                </span>
              </>
            )}
          </>
        );
      },
    },
    {
      Header: "NPI ID",
      accessor: "NPIID_CR",
      Cell: ({ row }) => {
        return (
          <>
            {row.id == "0" ? (
              <>
                <div
                  onMouseEnter={(e) =>
                    getCoordinates(e, row.original.NPI_Coordinates)
                  }
                  className="addProviderNpi1Focus"
                >
                  {row.values.NPIID_CR}
                </div>
              </>
            ) : (
              <>
                <div
                  onMouseEnter={(e) =>
                    getCoordinates(e, row.original.NPI_Coordinates)
                  }
                  className="addProviderNpi2Focus"
                >
                  {row.values.NPIID_CR}
                </div>
              </>
            )}
          </>
        );
      },
    },
    {
      Header: "Address",
      accessor: "Address_CR",
      Cell: ({ row }) => {
        return (
          <>
            {row.id == "0" ? (
              <>
                <span
                  onMouseEnter={(e) =>
                    getCoordinates(e, row.original.Address_Coordinates)
                  }
                  className={`addProviderAddress1Focus ${
                    props.confidenceCheck
                      ? row.original.Address_Confidence < 0.3
                        ? "before30Text"
                        : row.original.Address_Confidence < 0.7
                        ? "before70Text"
                        : ""
                      : ""
                  }`}
                >
                  {row.values.Address_CR}
                </span>
              </>
            ) : (
              <>
                <span
                  onMouseEnter={(e) =>
                    getCoordinates(e, row.original.Address_Coordinates)
                  }
                  className={`addProviderAddress2Focus ${
                    props.confidenceCheck
                      ? row.original.Address_Confidence < 0.3
                        ? "before30Text"
                        : row.original.Address_Confidence < 0.7
                        ? "before70Text"
                        : ""
                      : ""
                  }`}
                >
                  {row.values.Address_CR}
                </span>
              </>
            )}
          </>
        );
      },
    },
    {
      Header: "Phone No",
      accessor: "PhoneNumber_CR",
      Cell: ({ row }) => {
        return (
          <>
            {row.id == "0" ? (
              <>
                <div
                  onMouseEnter={(e) =>
                    getCoordinates(e, row.original.Phone_Coordinates)
                  }
                  className="addProviderPhone1Focus"
                >
                  {row.values.PhoneNumber_CR}
                </div>
              </>
            ) : (
              <>
                <div
                  onMouseEnter={(e) =>
                    getCoordinates(e, row.original.Phone_Coordinates)
                  }
                >
                  {row.values.PhoneNumber_CR}
                </div>
                <div className="addProviderPhone2FocusDiv"></div>
              </>
            )}
          </>
        );
      },
    },
    {
      Header: "Fax No",
      accessor: "FaxNo_CR",
      Cell: ({ row }) => {
        return (
          <>
            {row.id == "0" ? (
              <>
                <span
                  onMouseEnter={(e) =>
                    getCoordinates(e, row.original.Fax_Coordinates)
                  }
                  className={`addProviderFax1Focus ${
                    props.confidenceCheck
                      ? row.original.Fax_Confidence < 0.3
                        ? "before30Text"
                        : row.original.Fax_Confidence < 0.7
                        ? "before70Text"
                        : ""
                      : ""
                  }`}
                >
                  {row.values.FaxNo_CR}
                </span>
              </>
            ) : (
              <>
                <span
                  onMouseEnter={(e) =>
                    getCoordinates(e, row.original.Fax_Coordinates)
                  }
                  className={`${
                    props.confidenceCheck
                      ? row.original.Fax_Confidence < 0.3
                        ? "before30Text"
                        : row.original.Fax_Confidence < 0.7
                        ? "before70Text"
                        : ""
                      : ""
                  }`}
                >
                  {row.values.FaxNo_CR}
                </span>
                <div className="addProviderFax2FocusDiv"></div>
              </>
            )}
          </>
        );
      },
    },
    {
      Header: "Provider Type",
      accessor: "ProviderType_CR",
      Cell: ({ row }) => {
        return (
          <>
            <div className="addProviderType1Focus">
              {row.values.ProviderType_CR}
            </div>
          </>
        );
      },
    },
  ];

  const fieldClickHandel = () => {
    const image = imageRef.current;
    if (image) {
      image.onload = () => {
        console.log(
          "imageRef fieldClickHandel ===> ",
          image.width,
          image.height
        );
        props.setImageDimension({ height: image.height, width: image.width });
        setPdfImgWidth(image.width);
        setPdfImgHeight(image.height);
      };
    }

    // var myPdfImage = document.getElementById("myPdfImage");
    // // console.log("IMG CLICK HANDLE ===> ", myPdfImage.getBoundingClientRect());
    // if (pdfImgWidth == 0) {
    //   setPdfImgWidth(myPdfImage.getBoundingClientRect().width);
    // }
    // if (pdfImgHeight == 0) {
    //   setPdfImgHeight(myPdfImage.getBoundingClientRect().height);
    // }
  };

  // ======================= new pdfImg begin ==================
  function setBox(imgID, resultID) {
    var img, lens, result, cx, cy;
    img = document.getElementById(imgID);
    result = document.getElementById(resultID);
  }

  function hide_selector() {
    var result = document.getElementById("myresult");
    var lens = document.getElementById("highlightbox");
    result.style.display = "none";
    lens.style.display = "none";
  }

  function move_box_click(x, y, boxHeight, boxWidth, field = "") {
    // RESET ELEMENTS============================================================
    var img, result, x, y, cx, cy;
    var lens, imgContainer;

    // GET ELEMENTS============================================================
    lens = document.getElementById("highlightbox");
    img = document.getElementById("myPdfImage");
    result = document.getElementById("myresult");
    result.style.display = "";
    lens.style.display = "";

    // ADJUST HIGHLIGHT LENS BOX============================================================
    lens.style.left = x + "px";
    lens.style.top = y + "px";
    lens.style.height = boxHeight + "px";
    lens.style.width = boxWidth + "px";

    // GET ZOOM RESULT============================================================
    result.style.height = boxHeight + 10 + "px";
    result.style.width = boxWidth + 30 + "px";
    result.style.backgroundImage = "url('" + img.src + "')";
    result.style.backgroundSize = img.width + 30 + "px " + img.height + "px";
    result.style.backgroundPosition = "-" + x + "px -" + (y - 9) + "px";
    // result.style.backgroundPosition = "-" + x + "px -" + (y - 2) + "px";
    result.style.transform =
      field === "Additional Message" ? "scale(1.1)" : "scale(1.2)";

    // ZOOM BOX TOGGLE============================================================
    result.style.border = "1px solid #fb4e0b";
    if (zoomBoxOutPos) {
      // result.style.left = lens.style.left;
      result.style.left = parseInt(lens.style.left, 10) + 10 + "px";
      result.style.top = parseInt(lens.style.top, 10) + 0 + "px";
    } else {
      result.style.top = "-80px";
      result.style.right = "10px";
      result.style.left = "auto";
    }
  }

  const getHeightAndWidthOfElement = (elementId) => {
    let element = document.getElementById(elementId);
    if (!element) {
      return {
        width: 0,
        height: 0,
      };
    }
    return {
      width: element.getBoundingClientRect().width,
      height: element.getBoundingClientRect().height,
    };
  };

  function result_clicked(e) {
    var anchor;
    anchor = document.createElement("A");
    anchor.setAttribute("href", window.location.pathname + "#myresult");
    anchor.click();
    //console.log(window.location.pathname);
  }

  const getCoordinates = (e, coordinates, field = "") => {
    if (coordinates && coordinates !== "" && coordinates !== null) {
      move_box_click(
        coordinates.split(",")[0] * props.imageDimension.width,
        coordinates.split(",")[1] * props.imageDimension.height,
        coordinates.split(",")[3] * props.imageDimension.height -
          coordinates.split(",")[1] * props.imageDimension.height +
          2,
        coordinates.split(",")[2] * props.imageDimension.width -
          coordinates.split(",")[0] * props.imageDimension.width +
          2,
        field
      );
      // }
    } else {
      hide_selector();
    }
    result_clicked();
  };

  const updatedValue = (e, targetField) => {
    if (targetField == props.ocrData.MemberID.value) {
      setValidateFieldMemberId(true);
    } else if (targetField == props.ocrData.DOB.value) {
      setValidateFieldDob(true);
    } else if (targetField == props.ocrData.FirstName.value) {
      setValidateFieldFirstName(true);
    } else if (targetField == props.ocrData.LastName.value) {
      setValidateFieldLastName(true);
    } else if (targetField == props.ocrData.RequestorName.value) {
      setValidateFieldRequestorName(true);
    } else if (targetField == props.ocrData.RequestorPhone.value) {
      setValidateRequestorPhone(true);
    } else if (targetField == props.ocrData.RequestorFax.value) {
      setValidateFieldRequestorFax(true);
    } else if (targetField == props.ocrData.AnticipatedStartDate.value) {
      setValidateFieldAnticipatedStartDate(true);
    }
  };

  async function updateFieldValue_v2(e) {
    console.log(e.target.value, e.target.defaultValue);
    if (e.target.value != e.target.defaultValue) {
      // console.log(originalValue);
      const api = new Api_Call();
      const ret = await api.putData(`FAX/UPDATE-FIELD`, {
        userId: userId,
        taskId: sessionStorage.getItem("ActiveTaskID"),
        fieldName: e.target.name,
        newValue: e.target.value,
        op_type: "update",
      });
      toast.success(ret.body);

      //   const ret = await ApiCall(
      //     {
      //       userId: "1",
      //       taskId: sessionStorage.getItem("ActiveTaskID"),
      //       fieldName: e.target.name,
      //       newValue: e.target.value,
      //       op_type: "update",
      //     },
      //     "vcare-ui",
      //     "vcare_updatefield"
      //   );
      //   toast.success(ret.body);
    }
  }

  const readOriginalValue = (e) => {
    e.preventDefault();
    setOriginalValue(e.target.value);
  };

  async function updateFieldValue(e) {
    console.log(e.target.value, originalValue);
    if (e.target.value != originalValue) {
      setOriginalValue(e.target.value);
      const api = new Api_Call();
      const ret = await api.putData(`FAX/UPDATE-FIELD`, {
        userId: userId,
        taskId: sessionStorage.getItem("ActiveTaskID"),
        fieldName: e.target.name,
        newValue: e.target.value,
        op_type: "update",
      });
      toast.success(ret.body.msg);

      // setOriginalValue(e.target.value);
      // const ret = await ApiCall(
      //   {
      //     userId: "1",
      //     taskId: sessionStorage.getItem("ActiveTaskID"),
      //     fieldName: e.target.name,
      //     newValue: e.target.value,
      //     op_type: "update",
      //   },
      //   "vcare-ui",
      //   "vcare_updatefield"
      // );
      // toast.success(ret.body);
    }
  }

  // async function updateListFieldValue(e) {
  //     const ret = await ApiCall(
  //       {
  //         userId: "1",
  //         taskId: sessionStorage.getItem("ActiveTaskID"),
  //         fieldName: e.target.name,
  //         newValue: e.target.value,
  //         op_type: "update",
  //       },
  //       "vcare-ui",
  //       "vcare_updatefield"
  //     );
  //     toast.success(ret.body);
  // }

  async function updateFieldCoordinates(reqBodyObj) {
    setOpenMenu(false);
    setBackdropLoading(true);
    const api = new Api_Call();
    const data = await api.putData(`FAX/UPDATE-FIELD-COORDINATES`, reqBodyObj);
    var response = JSON.parse(JSON.stringify(data));
    props.setShowCanvas(false);
    props.getOCRDatafromAPI();
    props.getOCRDatafromAPI().then((data) => {
      setBackdropLoading(false);
      toast.success(response.body);
    });

    // setOpenMenu(false);
    // setBackdropLoading(true);
    // await ApiCall(
    //   reqBodyObj,
    //   "vcare-ui",
    //   "vcareui_updatefieldcoordinates"
    // ).then((data) => {
    //   var response = JSON.parse(JSON.stringify(data));
    //   props.setShowCanvas(false);
    //   props.getOCRDatafromAPI();
    //   props.getOCRDatafromAPI().then((data) => {
    //     setBackdropLoading(false);
    //     toast.success(response.body);
    //   });
    // });
  }

  useEffect(() => {
    setBox();
  }, []);

  const zoomInPdfImg = () => {
    document.getElementById("iframe-container").style.transform =
      "scale(1." + pdfImgScale + ")";
    if (pdfImgScale != 9) {
      setPdfImgScale(pdfImgScale + 1);
    }
  };
  const zoomOutPdfImg = () => {
    document.getElementById("iframe-container").style.transform =
      "scale(1." + pdfImgScale + ")";
    if (pdfImgScale != 0) {
      setPdfImgScale(pdfImgScale - 1);
    }
  };

  const pdfImgRangeFun = () => {
    var rangeVal = document.getElementById("Zoom").value;
    document.getElementById("myresult").style.transform =
      "scale(1." + rangeVal + ")";
  };
  // ======================= new pdfImg ends ==================

  const VeryHigh = () => {
    return (
      <>
        <div className="confidence-wrapper very-high-wrapper">
          <CheckCircleOutlineOutlinedIcon className="text-very-high" />
          {/* <span>Very High</span> */}
          <span>Complete</span>
        </div>
      </>
    );
  };
  const High = () => {
    return (
      <>
        {/* <div className="confidence-wrapper high-wrapper"> */}
        <div className="confidence-wrapper low-wrapper">
          {/* <div className="text-high"></div>  */}
          <CircularProgress
            variant="determinate"
            value={100}
            size={16}
            thickness={8}
            // style={{ color: "#2D9E08" }}
            style={{ color: "#ed0202" }}
          />
          {/* <span>High</span> */}
          <span>Not Complete</span>
        </div>
      </>
    );
  };
  const Medium = () => {
    return (
      <>
        {/* <div className="confidence-wrapper medium-wrapper"> */}
        <div className="confidence-wrapper low-wrapper">
          {/* <div className="text-medium"></div> */}
          <CircularProgress
            variant="determinate"
            value={100}
            size={16}
            thickness={8}
            // style={{ color: "#ed8402" }}
            style={{ color: "#ed0202" }}
          />
          {/* <span>Medium</span> */}
          <span>Not Complete</span>
        </div>
      </>
    );
  };
  const Low = () => {
    return (
      <>
        <div className="confidence-wrapper low-wrapper">
          {/* <div className="text-low"></div> */}
          <CircularProgress
            variant="determinate"
            value={100}
            size={16}
            thickness={8}
            style={{ color: "#ed0202" }}
          />
          {/* <span>Low</span> */}
          <span>Not Complete</span>
        </div>
      </>
    );
  };
  const Validated = () => {
    return (
      <>
        <div className="confidence-wrapper high-wrapper">
          <HowToRegTwoToneIcon sx={{ color: "#004EFF" }} />
          <span>Validated</span>
        </div>
      </>
    );
  };

  const MissingCoords = ({ field }) => {
    return (
      <>
        <div
          className="confidence-wrapper high-wrapper"
          title="Add Coordinates"
        >
          <AddLocationAltIcon
            sx={{ color: "#004EFF", cursor: "pointer" }}
            onClick={() => toggleCanvasImage(field)}
          />
        </div>
      </>
    );
  };
  const toggleCanvasImage = (field) => {
    setFormFieldName(field);
    setIsSelected(true);
    props.setShowCanvas(true);
    props.setSelectedField(field);
  };

  if (props.contentType == "fields") {
    if (props.fieldGroup == "validation") {
      return (
        <div style={{ display: props.display }}>
          <div className="group-label"></div>
          <div className="group-content">
            <FieldsClinical
              type="ready-only-text"
              fieldLabel="Prioritization:"
              txtId="Prioritization_CR"
              dataText={
                props.ocrData.Prioritization &&
                props.ocrData.Prioritization.value
              }
            ></FieldsClinical>
            <FieldsClinical
              type="ready-only-text"
              fieldLabel="Multiple Member:"
              txtId="txtMultipleMember"
              dataText={props.ocrData.isMultipleMember_YN == 1 ? "Yes" : "No"}
            ></FieldsClinical>
          </div>
        </div>
      );
    } else if (props.fieldGroup == "common_information") {
      return (
        <div style={{ display: props.display }}>
          <div onMouseOver={fieldClickHandel}>
            <div>
              <div>
                <div className="group-label">
                  <HeaderTitle
                    divStyle="header-div--sub"
                    headerStyle="header--primary"
                    headerSize="header--small"
                    divAlign="header--left"
                    textContent="Member Information"
                  ></HeaderTitle>
                </div>
                <div className="group-content">
                  {/* <div class="header">
                      HIPAA Validated
                  </div> */}
                  {/* <div onClick={result_clicked}></div> */}
                  <FieldsClinical
                    type="default"
                    taskStatus={props.taskStatus}
                    fieldLabel="Member ID:"
                    txtId="MemberID_CR"
                    datalabel="Member ID"
                    originalValue={readOriginalValue}
                    move_box_click={(e) =>
                      getCoordinates(e, props.ocrData.MemberID.coordinates)
                    }
                    updateStateValue={(e) =>
                      updatedValue(e, props.ocrData.MemberID.value)
                    }
                    updateField={(e) => updateFieldValue(e)}
                    dataText={
                      props.ocrData.MemberID && props.ocrData.MemberID.value
                    }
                    ocrData={props.ocrData}
                    //focusStyle="highlighterFocus"
                    focusStyle="memberidFocus"
                    focusStyleDiv="memberidDiv"
                    confidenceIcon={
                      props.confidenceCheck ? (
                        validateFieldMemberId ? (
                          <Validated />
                        ) : props.ocrData.MemberID.value == "" ? (
                          <Low />
                        ) : //) : props.ocrData.MemberID.confidence > 0.95 ? (
                        props.ocrData.MemberID.confidence >
                          props.maxConfidence ? (
                          <VeryHigh />
                        ) : (
                          <High />
                        )
                      ) : (
                        // ) : props.ocrData.MemberID.confidence > 0.8 ? (
                        //   <High />
                        // ) : props.ocrData.MemberID.confidence > 0.6 ? (
                        //   <Medium />
                        // ) : (
                        //   <Low />
                        // )
                        ""
                      )
                    }
                    missingCoords={
                      props.ocrData.MemberID.coordinates === "" ? (
                        <MissingCoords field={"MemberID"} />
                      ) : null
                    }
                  ></FieldsClinical>

                  <FieldsClinical
                    type="date"
                    taskStatus={props.taskStatus}
                    fieldLabel="Date of Birth:"
                    txtId="DateOfBirth_DT"
                    datalabel="Date of Birth"
                    move_box_click={(e) =>
                      getCoordinates(e, props.ocrData.DOB.coordinates)
                    }
                    updateStateValue={(e) =>
                      updatedValue(e, props.ocrData.DOB.value)
                    }
                    // updateField={e => updateFieldValue(e)}
                    dataText={Moment(props.ocrData.DOB.value).format(
                      "YYYY-MM-DD"
                      //"MM-DD-YYYY"
                    )}
                    setterMethod={props.setOCRData}
                    ocrData={props.ocrData}
                    focusStyle="dobFocus"
                    focusStyleDiv="dobFocusDiv"
                    confidenceIcon={
                      props.confidenceCheck ? (
                        validateFieldDob ? (
                          <Validated />
                        ) : props.ocrData.DOB.value == "" ? (
                          <Low />
                        ) : // ) : props.ocrData.DOB.confidence > 0.95 ? (
                        props.ocrData.DOB.confidence > props.maxConfidence ? (
                          <VeryHigh />
                        ) : (
                          <High />
                        )
                      ) : (
                        // ) : props.ocrData.DOB.confidence > 0.8 ? (
                        //   <High />
                        // ) : props.ocrData.DOB.confidence > 0.6 ? (
                        //   <Medium />
                        // ) : (
                        //   <Low />
                        // )
                        ""
                      )
                    }
                    missingCoords={
                      props.ocrData.DOB.coordinates === "" ? (
                        <MissingCoords field={"DOB"} />
                      ) : null
                    }
                  ></FieldsClinical>

                  <FieldsClinical
                    type="default"
                    taskStatus={props.taskStatus}
                    fieldLabel="Member First Name:"
                    txtId="FirstName_CR"
                    datalabel="First Name"
                    originalValue={readOriginalValue}
                    move_box_click={(e) =>
                      getCoordinates(e, props.ocrData.FirstName.coordinates)
                    }
                    updateStateValue={(e) =>
                      updatedValue(e, props.ocrData.FirstName.value)
                    }
                    updateField={(e) => updateFieldValue(e)}
                    dataText={props.ocrData.FirstName.value}
                    setterMethod={props.setOCRData}
                    ocrData={props.ocrData}
                    focusStyle="firstNameFocus"
                    focusStyleDiv="firstNameFocusDiv"
                    confidenceIcon={
                      props.confidenceCheck ? (
                        validateFieldFirstName ? (
                          <Validated />
                        ) : props.ocrData.FirstName.value == "" ? (
                          <Low />
                        ) : // ) : props.ocrData.FirstName.confidence > 0.95 ? (
                        props.ocrData.FirstName.confidence >
                          props.maxConfidence ? (
                          <VeryHigh />
                        ) : (
                          <High />
                        )
                      ) : (
                        // ) : props.ocrData.FirstName.confidence > 0.8 ? (
                        //   <High />
                        // ) : props.ocrData.FirstName.confidence > 0.6 ? (
                        //   <Medium />
                        // ) : (
                        //   <Low />
                        // )
                        ""
                      )
                    }
                    missingCoords={
                      props.ocrData.FirstName.coordinates === "" ? (
                        <MissingCoords field={"FirstName"} />
                      ) : null
                    }
                  ></FieldsClinical>
                  <FieldsClinical
                    type="default"
                    taskStatus={props.taskStatus}
                    fieldLabel="Member Last Name:"
                    txtId="LastName_CR"
                    datalabel="Last Name"
                    originalValue={readOriginalValue}
                    move_box_click={(e) =>
                      getCoordinates(e, props.ocrData.LastName.coordinates)
                    }
                    updateStateValue={(e) =>
                      updatedValue(e, props.ocrData.LastName.value)
                    }
                    updateField={(e) => updateFieldValue(e)}
                    dataText={props.ocrData.LastName.value}
                    setterMethod={props.setOCRData}
                    ocrData={props.ocrData}
                    focusStyle="lastNameFocus"
                    focusStyleDiv="lastNameFocusDiv"
                    confidenceIcon={
                      props.confidenceCheck ? (
                        validateFieldLastName ? (
                          <Validated />
                        ) : props.ocrData.LastName.value == "" ? (
                          <Low />
                        ) : // ) : props.ocrData.LastName.confidence > 0.95 ? (
                        props.ocrData.LastName.confidence >
                          props.maxConfidence ? (
                          <VeryHigh />
                        ) : (
                          <High />
                        )
                      ) : (
                        // ) : props.ocrData.LastName.confidence > 0.8 ? (
                        //   <High />
                        // ) : props.ocrData.LastName.confidence > 0.6 ? (
                        //   <Medium />
                        // ) : (
                        //   <Low />
                        // )
                        ""
                      )
                    }
                    missingCoords={
                      props.ocrData.LastName.coordinates === "" ? (
                        <MissingCoords field={"LastName"} />
                      ) : null
                    }
                  ></FieldsClinical>
                </div>
              </div>
              <div>
                <div className="group-label">
                  <HeaderTitle
                    divStyle="header-div--sub"
                    headerStyle="header--primary"
                    headerSize="header--small"
                    divAlign="header--left"
                    textContent="Requestor Information"
                  ></HeaderTitle>
                </div>
                <div className="group-content">
                  <FieldsClinical
                    type="default"
                    taskStatus={props.taskStatus}
                    fieldLabel="Requestor Name:"
                    txtId="RequestorName_CR"
                    originalValue={readOriginalValue}
                    move_box_click={(e) =>
                      getCoordinates(e, props.ocrData.RequestorName.coordinates)
                    }
                    updateStateValue={(e) =>
                      updatedValue(e, props.ocrData.RequestorName.value)
                    }
                    updateField={(e) => updateFieldValue(e)}
                    dataText={props.ocrData.RequestorName.value}
                    focusStyle="requestorNameFocus"
                    focusStyleDiv="requestorNameFocusDiv"
                    confidenceIcon={
                      props.confidenceCheck ? (
                        validateFieldRequestorName ? (
                          <Validated />
                        ) : props.ocrData.RequestorName.value == "" ? (
                          <Low />
                        ) : // ) : props.ocrData.RequestorName.confidence > 0.95 ? (
                        props.ocrData.RequestorName.confidence >
                          props.maxConfidence ? (
                          <VeryHigh />
                        ) : (
                          <High />
                        )
                      ) : (
                        // ) : props.ocrData.RequestorName.confidence > 0.8 ? (
                        //   <High />
                        // ) : props.ocrData.RequestorName.confidence > 0.6 ? (
                        //   <Medium />
                        // ) : (
                        //   <Low />
                        // )
                        ""
                      )
                    }
                    missingCoords={
                      props.ocrData.RequestorName.coordinates === "" ? (
                        <MissingCoords field={"RequestorName"} />
                      ) : null
                    }
                  ></FieldsClinical>
                  <FieldsClinical
                    type="default"
                    taskStatus={props.taskStatus}
                    fieldLabel="Contact Phone:"
                    txtId="RequestorContactNo_CR"
                    originalValue={readOriginalValue}
                    dataText={props.ocrData.RequestorPhone.value}
                    move_box_click={(e) =>
                      getCoordinates(
                        e,
                        props.ocrData.RequestorPhone.coordinates
                      )
                    }
                    updateStateValue={(e) =>
                      updatedValue(e, props.ocrData.RequestorPhone.value)
                    }
                    updateField={(e) => updateFieldValue(e)}
                    focusStyle="contactPhoneFocus"
                    focusStyleDiv="contactPhoneFocusDiv"
                    confidenceIcon={
                      props.confidenceCheck ? (
                        validateFieldRequestorPhone ? (
                          <Validated />
                        ) : props.ocrData.RequestorPhone.value == "" ? (
                          <Low />
                        ) : // ) : props.ocrData.RequestorPhone.confidence > 0.95 ? (
                        props.ocrData.RequestorPhone.confidence >
                          props.maxConfidence ? (
                          <VeryHigh />
                        ) : (
                          <High />
                        )
                      ) : (
                        // ) : props.ocrData.RequestorPhone.confidence > 0.8 ? (
                        //   <High />
                        // ) : props.ocrData.RequestorPhone.confidence > 0.6 ? (
                        //   <Medium />
                        // ) : (
                        //   <Low />
                        // )
                        ""
                      )
                    }
                    missingCoords={
                      props.ocrData.RequestorPhone.coordinates === "" ? (
                        <MissingCoords field={"RequestorPhone"} />
                      ) : null
                    }
                  ></FieldsClinical>
                  <FieldsClinical
                    type="default"
                    taskStatus={props.taskStatus}
                    fieldLabel="Contact Fax:"
                    txtId="RequestorFaxNo_CR"
                    originalValue={readOriginalValue}
                    dataText={props.ocrData.RequestorFax.value}
                    move_box_click={(e) =>
                      getCoordinates(e, props.ocrData.RequestorFax.coordinates)
                    }
                    updateStateValue={(e) =>
                      updatedValue(e, props.ocrData.RequestorFax.value)
                    }
                    updateField={(e) => updateFieldValue(e)}
                    focusStyle="contactFaxFocus"
                    focusStyleDiv="contactFaxFocusDiv"
                    confidenceIcon={
                      props.confidenceCheck ? (
                        validateFieldRequestorFax ? (
                          <Validated />
                        ) : props.ocrData.RequestorFax.value == "" ? (
                          <Low />
                        ) : // ) : props.ocrData.RequestorFax.confidence > 0.95 ? (
                        props.ocrData.RequestorFax.confidence >
                          props.maxConfidence ? (
                          <VeryHigh />
                        ) : (
                          <High />
                        )
                      ) : (
                        // ) : props.ocrData.RequestorFax.confidence > 0.8 ? (
                        //   <High />
                        // ) : props.ocrData.RequestorFax.confidence > 0.6 ? (
                        //   <Medium />
                        // ) : (
                        //   <Low />
                        // )
                        ""
                      )
                    }
                    missingCoords={
                      props.ocrData.RequestorFax.coordinates === "" ? (
                        <MissingCoords field={"RequestorFax"} />
                      ) : null
                    }
                  ></FieldsClinical>
                </div>
              </div>
              <div>
                <div className="group-label">
                  <HeaderTitle
                    divStyle="header-div--sub"
                    headerStyle="header--primary"
                    headerSize="header--small"
                    divAlign="header--left"
                    textContent="Service Request Information"
                  ></HeaderTitle>
                </div>
                <div className="group-content">
                  <FieldsClinical
                    type="date"
                    taskStatus={props.taskStatus}
                    fieldLabel="Service Request Date:"
                    txtId="ServiceRequestDate_DT"
                    originalValue={readOriginalValue}
                    dataText={Moment(
                      props.ocrData.ServiceRequestDate.value
                    ).format("YYYY-MM-DD")}
                    setterMethod={props.setOCRData}
                    ocrData={props.ocrData}
                    updateStateValue={(e) =>
                      updatedValue(e, props.ocrData.ServiceRequestDate.value)
                    }
                    // missingCoords={
                    //   props.ocrData.ServiceRequestDate.coordinates === "" ? (
                    //     <MissingCoords field={"RequestDate"} />
                    //   ) : null
                    // }
                  ></FieldsClinical>

                  <FieldsClinical
                    type="dropdown"
                    taskStatus={props.taskStatus}
                    fieldLabel="UM Review Type:"
                    txtId="txtUMReviewType"
                    originalValue={readOriginalValue}
                    dataText={""}
                    dropdownType={"umReviewtype"}
                    umReviewTypeCB={props.umReviewTypeCB}
                    setUMReviewTypeSelected={props.setUMReviewTypeSelected}
                    selectedUMReviewTypeData={props.selectedUMReviewTypeData}
                    // updateField={(e) => updateListFieldValue(e)}
                  ></FieldsClinical>
                  {props.mandatoryCheck ? (
                    <FieldsClinical
                      type="dropdown"
                      taskStatus={props.taskStatus}
                      fieldLabel="Request Profile:"
                      txtId="txtAdProfile"
                      originalValue={readOriginalValue}
                      dataText={""}
                      dropdownType={"requestProfile"}
                      requestProfileCB={props.requestProfileCB}
                      setSelectedRequestProfile={
                        props.setSelectedRequestProfile
                      }
                      requestProfileData={props.requestProfileData}
                    ></FieldsClinical>
                  ) : (
                    ""
                  )}
                  <FieldsClinical
                    type="date"
                    taskStatus={props.taskStatus}
                    fieldLabel="Anticipated Start Date:"
                    // txtId="txtAnticipatedStart"
                    // txtId="AnticipatedStart"
                    txtId="AnticipatedStartDate_DT"
                    originalValue={readOriginalValue}
                    dataText={Moment(
                      props.ocrData.AnticipatedStartDate.value
                    ).format("YYYY-MM-DD")}
                    // dataText="2013-01-08"
                    move_box_click={(e) =>
                      getCoordinates(
                        e,
                        props.ocrData.AnticipatedStartDate.coordinates
                      )
                    }
                    updateStateValue={(e) =>
                      updatedValue(e, props.ocrData.AnticipatedStartDate.value)
                    }
                    // updateField={e => updateFieldValue(e)}
                    setterMethod={props.setOCRData}
                    ocrData={props.ocrData}
                    focusStyle="dobFocus"
                    focusStyleDiv="dobFocusDiv"
                    confidenceIcon={
                      props.confidenceCheck ? (
                        validateFieldAnticipatedStartDate ? (
                          <Validated />
                        ) : props.ocrData.AnticipatedStartDate.value == "" ? (
                          <Low />
                        ) : // ) : props.ocrData.AnticipatedStartDate.confidence >
                        //   0.95 ? (
                        props.ocrData.AnticipatedStartDate.confidence >
                          props.maxConfidence ? (
                          <VeryHigh />
                        ) : (
                          <High />
                        )
                      ) : (
                        // ) : props.ocrData.AnticipatedStartDate.confidence >
                        //   0.8 ? (
                        //   <High />
                        // ) : props.ocrData.AnticipatedStartDate.confidence >
                        //   0.6 ? (
                        //   <Medium />
                        // ) : (
                        //   <Low />
                        // )
                        ""
                      )
                    }
                    missingCoords={
                      props.ocrData.AnticipatedStartDate.coordinates === "" ? (
                        <MissingCoords field={"StartDate"} />
                      ) : null
                    }
                  ></FieldsClinical>
                  <FieldsClinical
                    type="date"
                    taskStatus={props.taskStatus}
                    fieldLabel="Anticipated End Date:"
                    // txtId="txtAnticipatedEnd"
                    txtId="AnticipatedEnd"
                    datalabel="End Date"
                    dataText={Moment(
                      props.ocrData.AnticipatedEndDate.value
                    ).format("YYYY-MM-DD")}
                    updateStateValue={(e) =>
                      updatedValue(e, props.ocrData.AnticipatedEndDate.value)
                    }
                    // missingCoords={
                    //   props.ocrData.AnticipatedEndDate.coordinates === "" ? (
                    //     <MissingCoords field={"EndDate"} />
                    //   ) : null
                    // }
                  ></FieldsClinical>
                  {props.mandatoryCheck ? (
                    <FieldsClinical
                      type="dropdown"
                      taskStatus={props.taskStatus}
                      fieldLabel="Member Admission Source:"
                      txtId="txtAdSource"
                      originalValue={readOriginalValue}
                      dataText={""}
                      dropdownType={"admissionSource"}
                      admissionSourceCB={props.admissionSourceCB}
                      setAdmissionSourceSelected={
                        props.setAdmissionSourceSelected
                      }
                    ></FieldsClinical>
                  ) : (
                    ""
                  )}
                  {props.mandatoryCheck ? (
                    <FieldsClinical
                      type="dropdown"
                      taskStatus={props.taskStatus}
                      fieldLabel="Member Admission Type:"
                      txtId="txtAdType"
                      originalValue={readOriginalValue}
                      dataText={""}
                      dropdownType={"admissionType"}
                      admissionTypeCB={props.admissionTypeCB}
                      setAdmissionTypeSelected={props.setAdmissionTypeSelected}
                    ></FieldsClinical>
                  ) : (
                    ""
                  )}
                  <FieldsClinical
                    type="textarea-small"
                    taskStatus={props.taskStatus}
                    fieldLabel="Additional Message:"
                    //txtId="txtAddMsg"
                    txtId="AdditionalMessage_CR"
                    textAreaClass="textarea-small"
                    originalValue={readOriginalValue}
                    dataText={props.ocrData.AdditionalMessage.value}
                    move_box_click={(e) =>
                      getCoordinates(
                        e,
                        props.ocrData.AdditionalMessage.coordinates,
                        "Additional Message"
                      )
                    }
                    updateStateValue={(e) =>
                      updatedValue(e, props.ocrData.AdditionalMessage.value)
                    }
                    updateField={(e) => updateFieldValue(e)}
                    focusStyle="additionalMessageFocus"
                    focusStyleDiv="additionalMessageDiv"
                    confidenceIcon={
                      props.confidenceCheck ? (
                        props.ocrData.AdditionalMessage.value == "" ? (
                          <Medium />
                        ) : // <Low />
                        // props.ocrData.AdditionalMessage.confidence > 0.95 ? (
                        props.ocrData.AdditionalMessage.confidence >
                          props.maxConfidence ? (
                          <VeryHigh />
                        ) : (
                          <High />
                        )
                      ) : (
                        // ) : props.ocrData.AdditionalMessage.confidence > 0.8 ? (
                        //   <High />
                        // ) : props.ocrData.AdditionalMessage.confidence > 0.6 ? (
                        //   <Medium />
                        // ) : (
                        //   // <Low />
                        //   <Medium />
                        // )
                        ""
                      )
                    }
                    // missingCoords={
                    //   props.ocrData.AdditionalMessage.coordinates === "" ? (
                    //     <MissingCoords field={"Message"} />
                    //   ) : null
                    // }
                  ></FieldsClinical>

                  <FieldsClinical type="line-break"></FieldsClinical>

                  <Box
                    className={`d-block ${
                      props.confidenceCheck
                        ? // ? props.ocrData.DX.confidence < 0.3
                          props.ocrData["DiagnosisCodes"].confidence < 0.3
                          ? "before30Text"
                          : // : props.ocrData.DX.confidence < 0.7
                          props.ocrData["DiagnosisCodes"].confidence < 0.7
                          ? "before70Text"
                          : ""
                        : ""
                    }`}
                  >
                    <div className="cptAndDxWrapper">
                      <BasicTable
                        newEntry={props.newEntry}
                        setNewEntry={props.setNewEntry}
                        columns={columnsDX}
                        tableData={props.dxData}
                        dxData={props.dxData}
                        setDXData={props.setDXData}
                        tableType="editable"
                        AddButtonText="Add Diagnosis"
                        ButtonID="BtnDX"
                        taskStatus={props.taskStatus}
                      ></BasicTable>
                      <div>
                        {/* {props.ocrData.DX.confidence > 0.95 ? ( */}
                        {
                          // props.ocrData.DX.confidence > props.maxConfidence ? (
                          props.ocrData["DiagnosisCodes"].confidence >
                          props.maxConfidence ? (
                            <VeryHigh />
                          ) : (
                            <High />
                          )
                          // ) : props.ocrData.DX.confidence > 0.8 ? (
                          //   <High />
                          // ) : props.ocrData.DX.confidence > 0.6 ? (
                          //   <Medium />
                          // ) : (
                          //   <Low />
                          // )
                        }
                      </div>
                    </div>
                  </Box>

                  <FieldsClinical type="line-break"></FieldsClinical>
                  <Box
                    className={`d-block ${
                      props.confidenceCheck
                        ? // ? props.ocrData.CPT.confidence < 0.3
                          props.ocrData.CPTCodes.confidence < 0.3
                          ? "before30Text"
                          : // : props.ocrData.CPT.confidence < 0.7
                          props.ocrData.CPTCodes.confidence < 0.7
                          ? "before70Text"
                          : ""
                        : ""
                    }`}
                  >
                    <div className="cptAndDxWrapper">
                      <BasicTable
                        newEntry={props.newEntry}
                        setNewEntry={props.setNewEntry}
                        columns={columsCPT}
                        tableData={props.cptData}
                        cptData={props.cptData}
                        setCPTData={props.setCPTData}
                        tableType="editable"
                        AddButtonText="Add Procedure"
                        ButtonID="BtnCPT"
                        taskStatus={props.taskStatus}
                      ></BasicTable>

                      <div>
                        {/* {props.ocrData.CPT.confidence > 0.95 ? ( */}
                        {
                          // props.ocrData.CPT.confidence > props.maxConfidence ? (
                          props.ocrData.CPTCodes.confidence >
                          props.maxConfidence ? (
                            <VeryHigh />
                          ) : (
                            <High />
                          )
                          // ) : props.ocrData.CPT.confidence > 0.8 ? (
                          //   <High />
                          // ) : props.ocrData.CPT.confidence > 0.6 ? (
                          //   <Medium />
                          // ) : (
                          //   <Low />
                          // )
                        }
                      </div>
                    </div>
                  </Box>
                </div>
              </div>
              <div>
                <div className="group-label">
                  <HeaderTitle
                    divStyle="header-div--sub"
                    headerStyle="header--primary"
                    headerSize="header--small"
                    divAlign="header--left"
                    textContent={props.headerTitle}
                  ></HeaderTitle>
                </div>
                <div className="group-content">
                  <BasicTable
                    newEntry={props.newEntry}
                    setNewEntry={props.setNewEntry}
                    columns={columnsProvider}
                    tableData={props.providerData}
                    providerData={props.providerData}
                    setProviderData={props.setProviderData}
                    tableType="editable"
                    AddButtonText="Add Provider"
                    ButtonID="BtnProvider"
                    taskStatus={props.taskStatus}
                  ></BasicTable>
                </div>
              </div>
              <div className="group-label">
                {/* <HeaderTitle
                    divStyle="header-div--sub"
                    headerStyle="header--primary"
                    headerSize="header--small"
                    divAlign="header--left"
                    textContent="Comments"
                  ></HeaderTitle> */}
              </div>
              <div className="group-content">
                {/* <FieldsClinical
                      type="textarea-small"
                      taskStatus={props.taskStatus}
                      fieldLabel="Intake Comments:"
                      txtId="IntakeNotes_CR"
                      textAreaClass="textarea-small"
                      datalabel="Notes"
                      originalValue={readOriginalValue}
                      dataText={props.ocrData.IntakeNotes}
                      // updateStateValue={e =>
                      //   updatedValue(e, props.ocrData.Notes.value)
                      // }
                      updateField={e => updateFieldValue(e)}
                    ></FieldsClinical> */}
              </div>
            </div>
          </div>
        </div>
      );
    } else if (props.fieldGroup == "pdf_box") {
      return (
        <div style={{ display: props.display }}>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={backdropLoading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <div className="box-half" onMouseOver={fieldClickHandel}>
            <div className="box-header">
              <HeaderTitle
                divStyle="header-div--sub"
                headerStyle="header--sub"
                headerSize="header--small"
                divAlign="header--left"
                textContent="Prior Authorization - Fax Form"
              ></HeaderTitle>
            </div>
            <div
              className="halfbox-content-new"
              style={{ border: props.showCanvas ? "5px solid #fb4e0b" : "" }}
            >
              {props.showCanvas ? (
                <div className="toolbar-container">
                  <ul>
                    <li>EDIT MODE</li>
                  </ul>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleDialogClose}
                  >
                    CANCEL
                  </Button>
                </div>
              ) : (
                <div className="toolbar-container">
                  <ul>
                    <li> Document : </li>
                    <li>
                      <ZoomOutOutlinedIcon onClick={zoomOutPdfImg} />
                    </li>
                    <li>
                      <ZoomInOutlinedIcon onClick={zoomInPdfImg} />
                    </li>
                  </ul>
                  <div className="zoom-control-box">
                    Zoom Box :
                    <input
                      type="range"
                      id="Zoom"
                      defaultValue={5}
                      min="0"
                      max="9"
                      onChange={pdfImgRangeFun}
                    />
                  </div>
                </div>
              )}

              <div className="box-content box-content-document">
                {props.imageDimension.width === 0 &&
                  props.imageDimension.height === 0 && (
                    <Box className="loader-wrapper loader-fax-wrapper">
                      <div className="loader"></div>
                    </Box>
                  )}
                <div
                  id="iframe-container"
                  className="documentViewer img-zoom-container myPdfImageContainer"
                >
                  <div id="myresult" className="img-zoom-result"></div>
                  <div id="highlightbox" className="img-zoom-lens"></div>

                  {isSelected && (
                    <FormFieldsDialog
                      handleClickCancel={handleDialogClose}
                      handleClickUpdate={handleDialogUpdate}
                      open={openMenu}
                      setOpen={setOpenMenu}
                      message={props.selectedField}
                    />
                  )}
                  {props.showCanvas && (
                    <canvas
                      ref={canvasRef}
                      className="documentFramePageImg"
                      // id="myPdfImage"
                      onMouseDown={handleMouseDown}
                      onMouseMove={handleMouseMove}
                      onMouseUp={handleMouseUp}
                      style={{ width: "100%", cursor: "crosshair" }}
                    />
                  )}

                  <img
                    ref={imageRef}
                    src={props.pdfImg}
                    className="documentFramePageImg"
                    id="myPdfImage"
                    style={{ display: props.showCanvas ? "none" : "" }}
                  />
                </div>
              </div>

              <div className="box-footer"></div>
            </div>
          </div>
        </div>
      );
    }
  }
};
